import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { TranslateModule } from '@ngx-translate/core'

@Component({
  selector: 'gb-presenter-tools-advanced-options-container',
  imports: [CommonModule, MatIconModule, TranslateModule],
  templateUrl: './gb-presenter-tools-advanced-options-container.component.html',
  styleUrl: './gb-presenter-tools-advanced-options-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbPresenterToolsAdvancedOptionsContainerComponent {
  @Input() set expand(expand: boolean) {
    this.expanded = expand
  }

  @Input() enableCollapse = true

  expanded = false

  toggleExpand() {
    if (!this.enableCollapse) {
      return
    }
    this.expanded = !this.expanded
  }

  getClass() {
    if (!this.enableCollapse) {
      return 'expanded'
    }
    return this.expanded ? 'expanded' : ''
  }

  getStyle() {
    if (!this.enableCollapse) {
      return { outline: 'none', padding: '0px' }
    } else {
      return {}
    }
  }
}
